<div class="content-container bg-white">
    <h1 translate="administrateurs"></h1>

    <div class="btn-bar">
        <button class="btn btn-outline-secondary"
                (click)="exportBackoffices()"
                translate="exporterLesBackoffices"
                type="button">
        </button>
        
        <button class="btn btn-primary"
                [routerLink]="['/users/backoffices/create']"
                translate="creerUnNouveauBackoffice"
                type="button">
        </button>
    </div>

    <ngx-datatable
        class="material"
        (sort)="onSort($event)"
        [columnMode]="'force'"
        [externalSorting]="true"
        [footerHeight]="0"
        [headerHeight]="50"
        [messages]="{
              totalMessage: 'common.datatable.total' | translate
              }"
        [sorts]="[{prop: defaultSortProperty, dir: 'asc'}]"
        [reorderable]="false"
        [rowHeight]="75"
        [rows]="backoffices"
        [scrollbarH]="true">

        <ngx-datatable-column [width]="250" name="{{'users.table.user' | translate}}" prop="lastName">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div class="multi-values-cell">
                    {{ row.firstName }} {{ row.lastName }}
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="250" name="{{'users.table.contact' | translate}}" prop="" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
                @if (row.email) {
                    {{ row.email }}<br/>
                }
                @if (row.phone) {
                    {{ row.phone }}
                }
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="225" name="{{'users.table.address' | translate}}" prop="street">
            <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.street }}<br/>
                {{ row.postalCode }} {{ row.city }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="50" [sortable]="false" name="{{'users.table.state' | translate}}">
            <ng-template let-row="row" ngx-datatable-cell-template>
                @if (row.accountEnabled) {
                    <fa-icon class="text-success" [icon]="icons.toggleOn"></fa-icon>
                } @else {
                    <fa-icon class="text-danger" [icon]="icons.toggleOff"></fa-icon>
                }
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [width]="50" [sortable]="false">
            <ng-template let-row="row" ngx-datatable-cell-template>
                <button [routerLink]="['/users/backoffices', row.id]" class="btn btn-link btn-sm"
                        title="{{'common.tooltip.edit' | translate}}">
                    <fa-icon [icon]="icons.edit"></fa-icon>
                </button>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>
